export default __webpack_public_path__ + "static/fotel_podologiczny-c9f1699fc33bd5985b58e155c3dba6e4.jpg";